import { GET_SESSION_BOOKING_COUNTS } from "@graphql"
import { useQuery } from "@apollo/client"

const useSessionBookingCounts = (options = {}) => {
  const { data, loading, error } = useQuery(GET_SESSION_BOOKING_COUNTS, {
    ...options,
  })

  return {
    data,
    loading,
    error,
  }
}

export default useSessionBookingCounts
